import type { ReactNode } from 'react'
import { useQuery } from '@apollo/client/react'
import Spinner from '~/components/Spinner'
import { GQL_MY_ACCOUNT } from '~/gql/account/account'
import IdentityForm from '~/pages/account/components/IdentityForm'
import PasswordForm from '~/pages/account/components/PasswordForm'
import PreferencesCard from '~/pages/account/components/PreferencesCard'
import ProfileCard from '~/pages/account/components/ProfileCard'

/**
 * L'écran « Mon compte » (#77), sans cadre : le back-office le monte dans son
 * layout, l'espace apprenant dans le sien (`LearnerAccountPage`). À gauche ce
 * qui se modifie, à droite la carte profil — qui passe en tête sur téléphone,
 * c'est elle qu'on vient d'abord regarder. `extra` ajoute ce qui ne concerne
 * qu'un des deux espaces (l'aménagement de l'apprenant, #327).
 */
function AccountView({ extra }: { extra?: ReactNode }) {
  const { data, loading } = useQuery(GQL_MY_ACCOUNT)
  const account = data?.myAccount

  if (!account) {
    return loading
      ? <div className="flex justify-center p-16"><Spinner className="size-6 text-muted-foreground" /></div>
      : null
  }

  return (
    // Pas d'`items-start` : la carte profil s'étire à la hauteur de la colonne
    // de gauche, les deux colonnes finissent à la même ligne.
    <div className="grid gap-6 lg:grid-cols-[1fr_22rem]">
      <div className="flex flex-col gap-6">
        <IdentityForm account={account} />
        {/* Compte SSO, invité ou pas encore activé : aucun mot de passe à changer. */}
        {account.hasPassword && <PasswordForm />}
        <PreferencesCard />
        {extra}
      </div>
      <aside className="order-first flex flex-col lg:order-none">
        <ProfileCard account={account} />
      </aside>
    </div>
  )
}

export default AccountView
